'use client';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import '../../utils/VpPoly.mjs';
import '../VpAccordion/VpAccordion.mjs';
import '../VpAccordion/VpAccordionDivider.mjs';
import '../VpAccordion/VpAccordionItem.mjs';
import '../VpAccordion/VpAccordionItemHeader.mjs';
import '@vtmn-play/icons/react';
import '../VpAccordion/accordion-context.mjs';
import '../VpAccordion/accordion-item-context.mjs';
import { mergeProps } from '@vtmn-play/utils';
import '../VpAccordion/VpAccordionItemHeaderLabel.mjs';
import '../VpAccordion/VpAccordionItemHeaderSubline.mjs';
import '../VpAccordion/VpAccordionItemPanel.mjs';
import '../VpArticleCard/VpArticleCard.mjs';
import '../VpArticleCard/VpArticleCardBody.mjs';
import '../VpArticleCard/VpArticleCardMedia.mjs';
import '../VpArticleCard/VpArticleCardLegend.mjs';
import '../VpArticleCard/VpArticleCardTitle.mjs';
import '../VpArticleCard/VpArticleCardLabel.mjs';
import '../VpArticleCard/VpArticleCardAction.mjs';
import '../VpArticleCard/VpArticleCardFooter.mjs';
import '../VpArticleCard/VpArticleCardCaption.mjs';
import '@vtmn-play/assets/react';
import '../VpAsset/VpAsset.mjs';
import '../VpBadge/VpBadge.mjs';
import '../VpBreadcrumbs/VpBreadcrumbs.mjs';
import '../VpBreadcrumbs/VpBreadcrumbsItem.mjs';
import '../VpBreadcrumbs/VpBreadcrumbsLink.mjs';
import '../VpBreadcrumbs/VpBreadcrumbsCollapseTrigger.mjs';
import './VpButton.mjs';
import '../VpCheckbox/VpCheckbox.mjs';
import '../VpCheckbox/VpCheckboxControl.mjs';
import '../VpCheckbox/VpCheckboxInput.mjs';
import '../VpCheckbox/VpCheckboxLabel.mjs';
import '../VpChip/VpActionChip/VpActionChip.mjs';
import '../VpChip/VpCheckboxChip/VpCheckboxChip.mjs';
import '../VpChip/VpRadioGroupChip/VpRadioGroupChip.mjs';
import '../VpChip/VpRadioGroupChip/VpRadioGroupChipItem.mjs';
import '../VpChip/VpRadioGroupChip/VpRadioGroupChipItemInput.mjs';
import '../VpChip/VpRadioGroupChip/VpRadioGroupChipItemLabel.mjs';
import '../VpDivider/VpDivider.mjs';
import '../VpDrawer/drawer-context.mjs';
import '@vtmn-play/logic';
import '@xstate/react';
import 'react-dom';
import '../VpDrawer/VpDrawerBackdrop.mjs';
import '../VpDrawer/VpDrawerDialog.mjs';
import '../VpDrawer/VpDrawerHeader.mjs';
import '../VpDrawer/VpDrawerBody.mjs';
import '../VpDrawer/VpDrawerFooter.mjs';
import '../VpDrawer/VpDrawerCloseButton.mjs';
import '../VpDrawer/VpDrawerTriggerButton.mjs';
import '../VpFooter/VpFooter.mjs';
import '../VpFooter/VpFooterColumn.mjs';
import '../VpFooter/VpFooterNavigation.mjs';
import '../VpFooter/VpFooterNavigationItem.mjs';
import '../VpFooter/VpFooterNavigationLink.mjs';
import '../VpFooter/VpFooterRow.mjs';
import '../VpFooter/VpFooterAccordion/VpFooterAccordion.mjs';
import '../VpFooter/VpFooterAccordion/VpFooterAccordionHeader.mjs';
import '../VpFooter/VpFooterAccordion/VpFooterAccordionPanel.mjs';
import '../VpFooter/VpFooterSubNavigation/VpFooterSubNavigation.mjs';
import '../VpFooter/VpFooterSubNavigation/VpFooterSubNavigationHeader.mjs';
import '../VpFooter/VpFooterSubNavigation/VpFooterSubNavigationList.mjs';
import '../VpFormControl/VpFormControl.mjs';
import '../VpFormControl/VpFormLabel.mjs';
import '../VpFormControl/VpFormHelper.mjs';
import '../VpFormControl/VpFormError.mjs';
import '../VpIcon/VpIcon.mjs';
import '../VpIconButton/VpIconButton.mjs';
import '../VpInput/VpInput.mjs';
import '../VpInput/VpInputField.mjs';
import '../VpLink/VpLink.mjs';
import '../VpLink/VpLinkContent.mjs';
import '../VpLinkList/VpLinkList.mjs';
import '../VpLinkList/VpLinkListItem.mjs';
import { VpLoader } from '../VpLoader/VpLoader.mjs';
import '../VpNavigationHeader/VpNavigationHeader.mjs';
import '../VpNavigationHeader/VpNavigationHeaderRow.mjs';
import '../VpPrice/VpPrice.mjs';
import '../VpPrice/VpPriceLabel.mjs';
import '../VpPrice/VpPriceHelper.mjs';
import '../VpPrice/VpPriceAmount.mjs';
import '../VpProductCard/VpProductCard.mjs';
import '../VpProductCard/VpProductCardHeader.mjs';
import '../VpProductCard/VpProductCardBody.mjs';
import '../VpProductCard/VpProductCardMedia.mjs';
import '../VpProductCard/VpProductCardFooter.mjs';
import '../VpProductCard/VpProductCardTitle.mjs';
import '../VpProductCard/VpProductCardDescription.mjs';
import '../VpProductCard/VpProductCardReviews.mjs';
import '../VpRadioGroup/VpRadioGroup.mjs';
import '../VpRadioGroup/VpRadioGroupItem.mjs';
import '../VpRadioGroup/VpRadioGroupItemControl.mjs';
import '../VpRadioGroup/VpRadioGroupItemInput.mjs';
import '../VpRadioGroup/VpRadioGroupItemLabel.mjs';
import '../VpScoreRating/VpScoreRating.mjs';
import '../VpSelect/VpSelect.mjs';
import '../VpSelect/VpSelectField.mjs';
import '../VpSelect/VpSelectOption.mjs';
import '../VpSelect/VpSelectOptGroup.mjs';
import '../VpStarRating/VpStarRating.mjs';
import '../VpSticker/VpSticker.mjs';
import '../VpTextarea/VpTextarea.mjs';
import '../VpToggle/VpToggle.mjs';
import { useVpButtonContext } from './button-context.mjs';

const VpButtonContent = forwardRef(
  (props, ref) => {
    const { children, startSlot, endSlot, loadingSlot, ...restProps } = props;
    const { api } = useVpButtonContext();
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("span", { ref, ...mergeProps(api.getLabelProps(), restProps), children: [
        Boolean(startSlot) && !api.isIconOnly && /* @__PURE__ */ jsx("span", { ...api.getStartSlotProps(), children: startSlot }),
        children,
        Boolean(endSlot) && !api.isIconOnly && /* @__PURE__ */ jsx("span", { ...api.getEndSlotProps(), children: endSlot })
      ] }),
      api.isLoading && /* @__PURE__ */ jsx("span", { ...api.getLoadingSlotProps(), children: loadingSlot ? loadingSlot : /* @__PURE__ */ jsx(VpLoader, { ...api.getLoaderProps() }) })
    ] });
  }
);

export { VpButtonContent };
